import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import React from 'react'

const TenantPulldown = ({ tenants, updateInput, formState, formErrorState, attributeName }) => {

  return (
    <FormControl
        variant="standard"
        sx={{ width:"100%",minWidth:"120px" }}
      >
        <InputLabel
          id="location-label"
          error={formErrorState[attributeName]?.error && !formState[attributeName]}
        >
          Select Tenant
        </InputLabel>
        <Select
          labelId="tenant-label"
          id={attributeName}
          name={attributeName}
          value={formState[attributeName] || ""}
          label="Tenant"
          onChange={updateInput}
          error={
            formErrorState[attributeName]?.error && !formState[attributeName]
          }
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {tenants?.map((item)=>(
            <MenuItem value={item.tenantId} key={item.tenantId}>
            {item.tenantName}
          </MenuItem>
          ))}
        </Select>
        {formErrorState?.tenantId?.error && !formState?.tenantId && (
          <Typography variant="subtitle2" color={"error"} mt={1} fontSize={12}>
            This field is required
          </Typography>
        )}
      </FormControl>
  )
}

export default TenantPulldown